import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ethers } from "ethers";
import axios from "axios";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";

import Loading from "../../Components/Loader";
import ConnectWalletPopup from "../../Components/ConfirmPopup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

const Root = styled.div`
  background-image: url(${RightBackgroundImage});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem 8rem;
`;
const TextContractContainer = styled.div`
  margin: 3rem 0;
`;
const TextWrapper = styled.div`
  width: 80%;
`;
const ContractTextWrapper = styled.div`
  margin: 10px 0;
`;

const ContractText = styled.text`
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 500;
  margin: 0 20px;
`;
const Text = styled.input`
  width: 100%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  outline: none;
`;

const RadioTextWrapper = styled.div``;
const RadioText = styled.text``;
const RadioButtonWrapper = styled.div`
  font-size: 24px;
  margin: 5px 20px;
`;
const RadioButton = styled.input`
  padding: 0 40px;
`;
const RadioContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 5rem 0;
  width: 80%;
`;
const Button = styled.button`
  padding: 10px 8rem;
  font-size: 18px;
  border-radius: 25px;
  outline: none;
  border: none;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 10px;
`;
const Span = styled.span`
  margin: 15px 10px;
`;
const SelectWrapper = styled.div``;
const Select = styled.select`
  width: 80%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  cursor: pointer;
  outline: none;
`;
const Option = styled.option`
  width: 80%;
  font-size: 16px;
  padding: 15px 10px !important;
  background-color: rgba(255, 255, 255, 0.1);
  color: Black !important;
  border-radius: 8px;
  border: none;
  margin-left: 20px;
  cursor: pointer !important;
  outline: none;
`;

const TokenIdValues = styled.text`
  font-size: 18px;
  /* padding-left:15px; */
  /* padding-top:10px; */
  padding: 20px 0px 0 20px;
`;

const ManageCurrency = ({ allContractDetails }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const handleDeleteToken = (id) => {
    Swal.fire({
      title: "Delete Token",
      text: "Are you sure you want to delete",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes delete it",
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${baseUrl}/nftmarketplace/api/v1/delete_conversion_token?id=${id}`,
        };

        axios
          .request(config)
          .then((response) => {
            if (response?.data?.success == true) {
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.data?.message);
            }
            getAllCurrencies();
          })
          .catch((error) => {
            toast.error(error?.response?.data?.message || error?.message);
          });
      }
    });
  };
  const handleDeleteCurrency = (id, currency) => {
    Swal.fire({
      title: "Delete currency",
      text: "Are you sure you want to delete it",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes delete it",
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${baseUrl}/nftmarketplace/api/v1/delete_conversion_currency?id=${id}&currency=${currency}`,
        };

        axios
          .request(config)
          .then((response) => {
            if (response?.data?.success) {
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.data?.message);
            }
            getAllCurrencies();
          })
          .catch((error) => {
            toast.error(error?.response?.data?.message || error?.message);
          });
      }
    });
  };
  const [currencyData, setCurrencyData] = useState([]);
  const [tokenName, setTokenName] = useState("");
  const [contractAddress, setContractAddress] = useState("");
  const [currency, setCurrency] = useState("");
  const [symbol, setSymbol] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [conversionRate, setConversionRate] = useState("");
  const [loading, setLoading] = useState(false);
  const handleAddConversionRate = (value) => {
    setContractAddress(value?.token_address);
    setTokenName(value?.token_name);
    setCurrency("");
    setSymbol("");
    setConversionRate("");
    window.scrollTo(0, 0);
  };
  const handleEditConversionRate = (outerVal, innerVal) => {
    window.scrollTo(0, 0);
    setContractAddress(outerVal?.token_address);
    setTokenName(outerVal?.token_name);
    setSymbol(innerVal?.symbol);
    setCurrency(innerVal?.currency);
    setConversionRate(innerVal?.conversion_rate);
  };
  const handleSubmitAddCurrency = () => {
    if (!tokenName || tokenName == "") {
      toast.error("token name is required");
      return;
    }
    if (!currency || currency == "") {
      toast.error("currency is required");
      return;
    }
    if (!contractAddress || contractAddress == "") {
      toast.error("contract address is required");
      return;
    }
    if (!conversionRate || conversionRate == "" || conversionRate == 0) {
      toast.error("conversion rate is required");
      return;
    }
    setIsSubmit(true);
    setLoading(true);
    let data = {
      token_name: tokenName,
      token_address: contractAddress,
      currency: currency,
      symbol: symbol,
      conversion_rate: conversionRate,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/nftmarketplace/api/v1/add_conversion_rate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success("Currency added");
        clearData();
        setIsSubmit(false);
        setLoading(false);

        getAllCurrencies();
      })
      .catch((error) => {
        setIsSubmit(false);
        setLoading(false);
        toast.error(error?.response?.data?.message || error?.message);
      });
  };
  const getAllCurrencies = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/nftmarketplace/api/v1/fetch_all_conversion_rate`,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data.data);
        setCurrencyData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllCurrencies();
  }, [allContractDetails]);

  const clearData = () => {
    setContractAddress("");
    setTokenName("");
    setConversionRate("");
    setCurrency("");
    setSymbol("");
  };

  return (
    <>
      {loading && <Loading />}
      <Root>
        <ToastContainer />
        <Container>
          <h1>Add New Currency</h1>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Contract Address</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="0X129836.... 8989"
                value={contractAddress}
                onChange={(e) => setContractAddress(e.target.value)}
              />
            </TextWrapper>
          </TextContractContainer>

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Token Name</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="MLD"
                value={tokenName}
                onChange={(e) => setTokenName(e.target.value)}
              />
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Currency</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="USD"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              />
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Symbol</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                placeholder="$"
                value={symbol}
                onChange={(e) => setSymbol(e.target.value)}
              />
            </TextWrapper>
          </TextContractContainer>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Conversion Rate</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="number"
                placeholder="0.5"
                value={conversionRate}
                onChange={(e) => setConversionRate(e.target.value)}
              />
            </TextWrapper>
          </TextContractContainer>
          <Button onClick={handleSubmitAddCurrency}>Submit</Button>
        </Container>
        <Container>
          <h1>Available Currencies</h1>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Token Name</ContractText>
              <ContractText> Contract Address</ContractText>
            </ContractTextWrapper>
            {currencyData &&
              currencyData.length > 0 &&
              currencyData.map((val) => (
                <>
                  <ContractTextWrapper>
                    <ContractText> {val?.token_name}</ContractText>
                    <ContractText>
                      {" "}
                      {`${val?.token_address.slice(
                        0,
                        5
                      )}...${val?.token_address.slice(-5)}`}
                    </ContractText>
                    <button onClick={() => handleAddConversionRate(val)}>
                      Add
                    </button>
                    <button onClick={() => handleDeleteToken(val?._id)}>
                      Delete
                    </button>
                  </ContractTextWrapper>
                  <div>
                    {val?.conversion_rate &&
                      val.conversion_rate.map((value) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                            alignItems: "center",
                          }}
                        >
                          <div>currency : {value?.currency}</div>
                          <div>conversion rate : {value?.conversion_rate}</div>
                          <div>
                            <button
                              onClick={() =>
                                handleEditConversionRate(val, value)
                              }
                            >
                              Edit
                            </button>
                            <button
                              onClick={() =>
                                handleDeleteCurrency(val?._id, value?.currency)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              ))}
          </TextContractContainer>
        </Container>
      </Root>
    </>
  );
};

export default ManageCurrency;
